import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { TableRow, TableCell } from '@mui/material';
import { confirmDialog } from '../Reusable/ConfirmDialog';
import ModalForUpdateBrand from './ModalForUpdateBrand';

const BrandRow = ({
  brand,
  updateBrand,
  deleteBrand,
  dispatch,
  brandReducer,
  clearValidationErrors,
}) => {
  const [show, setShow] = useState(false);

  const onDeleteClick = (id) => {
    const action = () => {
      dispatch(deleteBrand(id));
    };
    confirmDialog('obrišete brend ', action, ', obriši!');
  };

  const showModalUpdate = () => {
    setShow(true);
  };

  const handlePreviewClose = () => {
    setShow(false);
    clearValidationErrors();
  };

  const handleEdit = (brand) => {
    dispatch(updateBrand(brand, handlePreviewClose));
  };

  let row = (
    <>
      <TableRow>
        <TableCell>{brand.brandName}</TableCell>

        <TableCell className="text-center" id="centerRow">
          <Link to="#" onClick={() => showModalUpdate()}>
            <i className="fas fa-edit fa-2x i" />
          </Link>
        </TableCell>
        <TableCell
          className={`text-center ${brand.id === 2 && 'disable-events'}`}
        >
          <Link to="#" id="deleteBrand" onClick={() => onDeleteClick(brand.id)}>
            <i
              className={`fas fa-trash-alt fa-2x ${
                brand.id === 2 && 'disable-color'
              }`}
            />
          </Link>
        </TableCell>
      </TableRow>
    </>
  );

  return (
    <>
      {row}

      {show && (
        <ModalForUpdateBrand
          show={show}
          brand={brand}
          updateBrand={handleEdit}
          handleClose={handlePreviewClose}
          brandReducer={brandReducer}
        />
      )}
    </>
  );
};

export default BrandRow;
